import { render, staticRenderFns } from "./agam_ReleaseDetails.vue?vue&type=template&id=ff5df81e&"
import script from "./agam_ReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./agam_ReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./agam_ReleaseDetails.vue?vue&type=style&index=0&id=ff5df81e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports